import "../scss/login.scss";
import {AjaxRequest} from "./ajax-request";
import {Modal} from './modal.js';
import {ErrorMsg} from './error_model'
import {togglePassword} from "./passwordToggle";
import * as translations from "./translations";
import * as translation from "./translations";
import {getItem} from "./localStorage";

togglePassword('#password_toggle');

const errors = new ErrorMsg().errorsCode;
console.log(errors[2.1])


let membershipSelected = getItem('membership');

if (!membershipSelected) {
    document.querySelector('.register_row').style.display = "none";
}


const ajaxRequest = new AjaxRequest();
const modal = new Modal();
const spinner = document.querySelector('.spinner');
$(document).ready(function () {
    $('#login_form').validate({
        rules: {
            login: {
                required: true,

            },
            password: {
                required: true,
            },
        },
        errorElement: "span",
        errorPlacement: function (error, element) {
            error.addClass('error-message');
            error.insertAfter(element);
        },
        messages: {
            login: {
                email: translation.translations[translation.lang].emailError,
                required: translation.translations[translation.lang].required,
            },
            password: {
                required: translation.translations[translation.lang].required,
            },
        },
        submitHandler: function (form) {
            let data = {}
            $(form).serializeArray().forEach(obj => {
                data[obj.name] = obj.value
            })

            loginUser(data).then(res => {
                if (res['data']?.errors) {
                    let code = res['data']['errors'][0]['responseCode'];
                    if (errors[translations.lang][code.trim()]) {
                        modal.show(errors[translations.lang][code.trim()])
                    } else {
                        modal.show(translations.translations[translations.lang].sendError)
                    }
                } else if (res['logged']) {
                    if (!order) {
                        debugger
                        window.location.href = '/profil' + (lang !== 'pl' ? '_' + lang : '');
                    } else {
                        window.location.href = '/order' + (lang !== 'pl' ? '_' + lang : '');
                    }
                }
            })
        }
    });
});


async function loginUser(data) {
    spinner.style.display = "flex"
    try {
        let response = await ajaxRequest.request('my_ajax_login_user', data);
        debugger
        spinner.style.display = "none"
        return response
    } catch (error) {
        spinner.style.display = "none"
        return error

    }
}

const params = new URLSearchParams(window.location.search);
const order = params.get('order_id');
const lang = translations.lang

